import { useMutation } from '@tanstack/react-query';
import detachCredits from '../../api/credits/detach-credits';

type UseDetachCreditsArgs = {
    refetchCart: () => Promise<void>;
};

const useDetachCredits = ({ refetchCart }: UseDetachCreditsArgs) =>
    useMutation({
        mutationFn: detachCredits,
        // TODO FE-249 Stage 2: swap for refetchCart(queryClient) once the cart moves to React Query
        onSuccess: refetchCart
    });

export default useDetachCredits;
